import { Component, OnInit } from '@angular/core';
import { RouteAnimationShared } from 'src/app/utils/route-animation-shared';
import { GenerateShared } from '../../general/shared/generate-shared';
import { Location } from '@angular/common';
import { GenerateService } from 'src/app/data/repository/generate-repository/generate.service';

@Component({
  selector: 'app-diet-type-overview',
  templateUrl: './diet-type-overview.component.html',
  styleUrls: ['./diet-type-overview.component.scss'],
})
export class DietTypeOverviewComponent implements OnInit {
  dataIsReady = false;

  constructor(
    public generateShared: GenerateShared,
    private location: Location,
    private generateService: GenerateService,
    private routeAnimationShared: RouteAnimationShared
  ) {
    if (!this.generateShared.selectedDietType) {
      this.cancel();
    } else {
      this.dataIsReady = true;
    }
  }

  ngOnInit() {}

  cancel() {
    this.routeAnimationShared.showRouteAnimation();
    this.location.back();
    setTimeout(() => {
      // this.generateShared.selectedDietType = null;
      this.generateShared.goal = null;
      this.generateShared.isCanceling = false;
    }, 100);
  }

  start() {
    if (
      this.generateShared.selectedDietType.isPersonal ||
      this.generateShared.selectedDietType.fasting
    ) {
      this.generateService.goToDietPersonalType();
    } else {
      this.generateService.goToGenerate();
    }
  }
}
